/*
// 真留通用计算。
// 注：如有修改，需与后端同步更新。
*/

import {
  runStringExtender
} from "vue-js-extender";
runStringExtender();

import global_ from "./global";

const getCurrencyPrice = function (priceCAD, priceCNY, currency = global_.currencyType.CAD) {
  let price = 0;

  switch (currency) {
    case global_.currencyType.CNY:
      price = `${priceCNY}`.toNumber();
      break;
    case global_.currencyType.CAD:
      price = `${priceCAD}`.toNumber();
      break;
  }

  return price;
};

const calculateCountQuantityTotal = function (rangeLimitEnable, rangeLimitType, rangeLimitValue, countLimitEnable, countLimitType, countLimitValue) {
  let numRangeLimitValue = `${rangeLimitValue}`.toNumber();
  let numCountLimitValue = `${countLimitValue}`.toNumber();

  if (!numCountLimitValue)
    return 0;

  if (!rangeLimitEnable || countLimitType === global_.enumSACountLimitType.Total)
    return numCountLimitValue;

  let multiple = numRangeLimitValue;
  if (countLimitType === global_.enumSACountLimitType.Monthly && rangeLimitType === global_.enumSARangeLimitType.Year)
    multiple *= 12;

  return numCountLimitValue * multiple;
};

const calculateTimeQuantityTotal = function (rangeLimitEnable, rangeLimitType, rangeLimitValue, timeLimitEnable, timeLimitType, timeLimitValue) {
  let numRangeLimitValue = `${rangeLimitValue}`.toNumber();
  let numTimeLimitValue = `${timeLimitValue}`.toNumber();

  if (!numTimeLimitValue)
    return 0;

  if (!rangeLimitEnable || timeLimitType === global_.enumSATimeLimitType.Total)
    return numTimeLimitValue;

  let multiple = numRangeLimitValue;
  if (timeLimitType === global_.enumSATimeLimitType.Monthly && rangeLimitType === global_.enumSARangeLimitType.Year)
    multiple *= 12;

  return numTimeLimitValue * multiple;
};

export const calculateQuantityTotal = function (serviceType, rangeLimitEnable, rangeLimitType, rangeLimitValue, countLimitEnable, countLimitType, countLimitValue, timeLimitEnable, timeLimitType, timeLimitValue) {
  if (serviceType === global_.enumSAServiceType.AutoAttrition)
    return `${rangeLimitValue}`.toNumber();

  if (timeLimitEnable)
    return calculateTimeQuantityTotal(rangeLimitEnable, rangeLimitType, rangeLimitValue, timeLimitEnable, timeLimitType, timeLimitValue);

  return calculateCountQuantityTotal(rangeLimitEnable, rangeLimitType, rangeLimitValue, countLimitEnable, countLimitType, countLimitValue);
};

export const calculateQuantityTotalBySI = function (serviceItem) {
  return calculateQuantityTotal(
    serviceItem.ServiceType,
    serviceItem.RangeLimitEnable,
    serviceItem.RangeLimitType,
    serviceItem.RangeLimitValue,
    serviceItem.CountLimitEnable,
    serviceItem.CountLimitType,
    serviceItem.CountLimitValue,
    serviceItem.TimeLimitEnable,
    serviceItem.TimeLimitType,
    serviceItem.TimeLimitValue
  );
};

export const calculateMarketPrice = function (totalPrice, pcPriceTotal) {
  return totalPrice - pcPriceTotal;
};

export const calculateMarketPriceBySI = function (serviceItem, fieldName) {
  let quantityTotal = calculateQuantityTotalBySI(serviceItem);
  let unitPCPrice = serviceItem.PriceCategoryInfos.sum((item) => `${item[fieldName]}`.toNumber());
  let pcPriceTotal = unitPCPrice * quantityTotal;
  let totalPrice = `${serviceItem[fieldName]}`.toNumber() * quantityTotal;

  return calculateMarketPrice(totalPrice, pcPriceTotal);
};

export const calculateProfit = function (totalPrice, macketPrice, commissionRate) {
  return macketPrice - totalPrice * commissionRate;
};

export const calculateProfitBySI = function (serviceItem, commissionRate, currency = global_.currencyType.CAD) {
  let quantityTotal = calculateQuantityTotalBySI(serviceItem);
  let totalPrice = getCurrencyPrice(serviceItem.SalePriceCAD, serviceItem.SalePriceCNY, currency) * quantityTotal;
  let fieldName = `SalePrice${global_.currencyType.getAttrValue(currency, "key", String.empty)}`;
  let marketPrice = calculateMarketPriceBySI(serviceItem, fieldName);

  return calculateProfit(totalPrice, marketPrice, commissionRate);
};

export const calculateProfitRate = function (totalPrice, profitPrice) {
  return !!totalPrice ? profitPrice / totalPrice : 0;
};

export const calculateProfitRateBySI = function (serviceItem, commissionRate, currency = global_.currencyType.CAD) {
  let quantityTotal = calculateQuantityTotalBySI(serviceItem);
  let totalPrice = getCurrencyPrice(serviceItem.SalePriceCAD, serviceItem.SalePriceCNY, currency) * quantityTotal;
  let profitPrice = calculateProfitBySI(serviceItem, commissionRate, currency);

  return calculateProfitRate(totalPrice, profitPrice);
};



// WEBPACK FOOTER //
// ./src/core/studyAbroadHelper.js